import { Box } from "@chakra-ui/react";
import ExternalUserChatProfile from "./ExternalUserChatProfile";

function SearchGroup({
  values,
  userInfo,
  searchResult,
  selectedBorderColor,
  setRoomID,
  handleGetChats,
  setSelectedChat,
  selectedChat,
  selectChatBg,
}) {
  return searchResult && searchResult?.length > 0
    ? searchResult?.map((group) => {
        return (
          <Box
            key={group?.id}
            borderRadius={"7px"}
            p="7px"
            cursor={"pointer"}
            onClick={() => {
              setSelectedChat(group?.group_chat?.id);
              setRoomID(group?.group_chat_id);
              handleGetChats(group?.group_chat?.id);
            }}
            bg={selectedChat === group?.group_chat?.id ? selectChatBg : null}
            border={
              selectedChat === group?.group_chat?.id
                ? `1px solid ${selectedBorderColor}`
                : null
            }
          >
            <ExternalUserChatProfile
              id={group?.group_chat?.id}
              group={group}
              userInfo={userInfo}
            />
          </Box>
        );
      })
    : null;
}

export default SearchGroup;
